/* eslint-disable */
import React, { useState, useEffect } from 'react';
import './SubscriptionSuccess.css';
import { useTranslation } from 'react-i18next';
import {paypalService} from "../../api/payPal";
import {useNavigate} from "react-router-dom";
import {clearBrowserStorage} from "../../utils/funnelHelpers";

interface PayPalSuccessParams {
    setup_intent: string | null;
    setup_intent_client_secret: string | null;
    redirect_status: string | null;
    email?: string | null;
}

const PayPalSuccess: React.FC = () => {
    const { t } = useTranslation();
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [subscriptionPlanName, setSubName ] = useState<any>()
    const [urlParams, setUrlParams] = useState<PayPalSuccessParams>({
        setup_intent: null,
        setup_intent_client_secret: null,
        redirect_status: null,
        email: null
    });

    // Parse URL parameters on component mount
    useEffect(() => {
        const parseUrlParams = () => {
            const urlParams = new URLSearchParams(window.location.search);
            const params: PayPalSuccessParams = {
                setup_intent: urlParams.get('setup_intent'),
                setup_intent_client_secret: urlParams.get('setup_intent_client_secret'),
                redirect_status: urlParams.get('redirect_status'),
                email: urlParams.get('email')
            };

            setUrlParams(params);

            // Log the parsed parameters for debugging
            console.log('PayPal Success URL Parameters:', params);
            if(params.setup_intent && params.setup_intent_client_secret && params.redirect_status ==='succeeded'){
                createSimplePaypalSub()
            }


            // Validate required parameters
            if (!params.setup_intent || !params.redirect_status) {
                setError('Missing required payment parameters');
                return;
            }

            // Check if payment was successful
            if (params.redirect_status !== 'succeeded') {
                window.location.href = '/checkout'
                setError(`Payment failed with status: ${params.redirect_status}`);
                return;
            }

            // Here you can add additional logic to verify the payment with your backend
            // For example, you might want to call your API to confirm the payment_intent
        };

        parseUrlParams();

        const subscriptionPlan = localStorage.getItem('subscriptionPlan') || ''
        setSubName(subscriptionPlan)
    }, []);

    const createSimplePaypalSub = async () => {
      const customerId =  localStorage.getItem('customerId')
      const paymentId =  localStorage.getItem('paymentMethodId')
      const priceId =  localStorage.getItem('priceId')
      const secondPrice =  localStorage.getItem('secondPriceId')
      const userEmail = localStorage.getItem('userEmail')
        if(customerId && paymentId && priceId){
            const result = await paypalService.createSimpleSubscription({
                    customerId,
                    priceId,
                    secondPrice: secondPrice || '',
                    paymentMethodId: paymentId,
                })
            if(result.subscription || result.object === 'subscription'){
                const intervalTimer = setInterval(() => {
                    paypalService.trackPaypalInvoice(result.object === 'subscription' ? result.id : result.subscription).then(invoice => {
                        if(invoice.status === 'paid'){
                            clearInterval(intervalTimer);
                            clearBrowserStorage();
                            window.location.href = `${process.env.REACT_APP_PRODUCT_URL}/pin?email=${userEmail}`
                        }
                    })
                }, 2000)
            }
        }
    }

    if (loading) {
        return <div>{t('subscriptionSuccess.processing')}</div>;
    }

    if (error) {
        return <div className="subscription-error">{error}</div>;
    }

    return (
        <div className="subscription-success-bg">
            <div className="subscription-success-container">
                <div className="subscription-success-card">
                    {/* Top Icon */}
                    <div className="subscription-success-icon">
                        <img src="/images/circle-check-big.png" alt="Success" className="success-check-icon" />
                    </div>

                    {/* Main Title */}
                    <h1 className="subscription-success-title">{t('subscriptionSuccess.welcomeTitle')}</h1>

                    {/* Subtitle with emoji */}
                    <p className="subscription-success-subtitle">
                        {t('subscriptionSuccess.subtitle')}
                    </p>

                    {/* Plan Section */}
                    <div className="subscription-plan-section">
                        <span className="plan-label">{t('subscriptionSuccess.planLabel')}</span>
                        <span className="plan-name">{subscriptionPlanName}</span>
                    </div>
                    {/* Features Section */}
                    <div className="subscription-features-section">
                        <h2 className="features-title">{t('subscriptionSuccess.featuresTitle')}</h2>
                        <div className="features-list">
                            <div className="feature-item">
                                <span className="feature-check">✅</span>
                                <span>{t('subscriptionSuccess.features.courses')}</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✅</span>
                                <span>{t('subscriptionSuccess.features.personalized')}</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✅</span>
                                <span>{t('subscriptionSuccess.features.assistant')}</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✅</span>
                                <span>{t('subscriptionSuccess.features.certificates')}</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✅</span>
                                <span>{t('subscriptionSuccess.features.community')}</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✅</span>
                                <span>{t('subscriptionSuccess.features.updates')}</span>
                            </div>
                        </div>
                    </div>

                    {/* Support Section */}
                    <div className="subscription-support-section">
                        <p className="support-text">{t('subscriptionSuccess.supportText')}</p>
                        <a href={`mailto:${t('subscriptionSuccess.supportEmail')}`} className="support-email">
                            {t('subscriptionSuccess.supportEmail')}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PayPalSuccess;
